class UserJobEditController {
  constructor(JobsService, $scope, $window) {
    "ngInject";
    this.JobsService = JobsService;
    this.$scope = $scope;
    this.$window = $window;
  }

  $onInit() {
    const dataSource = this.JobsService.getJugglerJobsDataSource(this.userId);

    dataSource.bind('requestEnd', (e) => {
      if (e.type === 'update' && e.response) {
        this.$scope.$applyAsync();
        this.$window.location.reload();
      }
    });

    this.gridOptions = {
      dataSource,
      sortable: true,
      pageable: true,
      resizable: true,
      editable: 'inline',
      noRecords: {
        template: 'No Jobs found.'
      },
      columns: [
        { field: 'id', title: 'ID', width: '2rem', filterable: false, template: '#= data.id || data.jobId || data.JobId || data.Id || "" #' },
        { field: 'paymentType', title: 'Payment Type', width: '4rem', filterable: false, template: '#= data.paymentType || data.PaymentType || "" #' },
        { field: 'jobDate', title: 'Job Date', width: '3.5rem', filterable: false, template: `#= (data.jobDate || data.JobDate) ? kendo.toString(new Date(data.jobDate || data.JobDate), 'dd/MM/yyyy') : "" #` },
        { field: 'estimatedJobHours', title: 'Est. Hours', width: '3rem', filterable: false, template: '#= data.estimatedJobHours || data.EstimatedJobHours || "" #' },
        { field: 'price', title: 'Price', width: '3rem', filterable: false, template: '#= data.price || data.Price || 0 #' },
        { field: 'overtimeRate', title: 'Overtime Rate', width: '3.5rem', filterable: false, template: '#= data.overtimeRate || data.OvertimeRate || 0 #' },
        { field: 'estimatedJobValue', title: 'Est. Value', width: '3rem', filterable: false, template: '#= data.estimatedJobValue || data.EstimatedJobValue || 0 #' },
        { command: ['edit'], title: 'Actions', width: '3.5rem' },
      ]
    };
  }
}

export default UserJobEditController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-job-edit/user-job-edit.controller.js
 **/